import React, {useContext} from 'react';
import {InsuranceContext} from "../InsuranceContext";
import TitleInsurance from "../TitleInsurance";
import InsuranceInput from "../InsuranceInput";
import InsuranceInputHolder from "../InsuranceInput/InsuranceInputHolder";
import {optionArray} from "../functions";

function IranInsurance(props) {
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData

  console.log(myData)

  const FORM_OBJECTS = [//
    // {title: "plate", type: 'string', name: 'plate', required: true, }, //
    //  {title: "submitDate", type: 'string', name: 'submitDate', required: true,   }, //
    // {title: "firstInstallmentDate", type: 'date', name: 'firstInstallmentDate', required: true,   }, //
    // {title: "totalInstallment", type: 'string', name: 'totalInstallment', required: true,   }, //
    // {title: "defaultPercent", type: 'string', name: 'defaultPercent', required: true,   }, //
    // {title: "depositStatus", type: 'string', name: 'depositStatus', required: true,   }, //
    // {title: "depositBankId", type: 'rlookup', name: 'depositBankId', required: true, rlookupId:"42"  }, //


  ]//
  const objectKey = 'iranInsurance'

   const depositStatusOptions = optionArray(myData?.selectBoxData?.depositStatus)
  const functionAfterSelectBank = (response)=>{
    const sendData = {...myData.sendData}
    sendData[objectKey]['bankId'] = response['na_99'] ? response['na_99'] : ""
    setMyData({sendData})

  }
  return (<div>
    <TitleInsurance title={'بیمه ایران'}/>
    <div className={'insurance__box border__insurance'}>


      {/*<InsuranceInputHolder*/}
      {/*  objectKey={objectKey}*/}
      {/*  row={{title: "تاریخ سابمیت فرم", type: 'string', name: 'submitDate', required: true,}//*/}
      {/*  }*/}
      {/*/>*/}

      <InsuranceInputHolder
        objectKey={objectKey}
        row={{title: "تاریخ شروع قسط", type: 'date', name: 'firstInstallmentDate', required: true,
        placeholder:"تاریخ شروع قسط"
        }//
        }
      />
      {/*<InsuranceInputHolder*/}
      {/*  objectKey={objectKey}*/}
      {/*  row={{title: "totalInstallment", type: 'string', name: 'totalInstallment', required: true,}//*/}
      {/*  }*/}
      {/*/>*/}

      {/*<InsuranceInputHolder*/}
      {/*  objectKey={objectKey}*/}
      {/*  row={{*/}
      {/*    title: "defaultPercent", type: 'string', name: 'defaultPercent', required: true,*/}
      {/*  }//*/}
      {/*  }*/}
      {/*/>*/}


      {/*<InsuranceInputHolder*/}
      {/*  objectKey={objectKey}*/}
      {/*  row={{*/}
      {/*    title: "depositStatus", type: 'selectBox', name: 'depositStatus', required: true, options: depositStatusOptions*/}
      {/*  }////*/}
      {/*  }*/}
      {/*/>*/}

      <InsuranceInputHolder

        objectKey={objectKey}
        functionAfterSelect={functionAfterSelectBank}

        row={//
          {title: "کد بانک",
            type: 'rlookup',
            name: 'bankId',
            required: true,
            rlookupId: myData.initialData.bankRLookUpId,//
            placeholder: "کد بانک",

          }}
      />


    </div>

  </div>);
}

export default IranInsurance;